import { Checkbox, Dialog } from '@cimplico/components';
import { useState } from 'react';
import { toastNotification } from '../../../components/toast/Toast';
import { useReplaceDocument } from '../../../queries/use-replace-document';
import { FileRecordNew } from '../../../types/file-record';

type DocumentReplaceConfirmProps = {
    currentRecord: FileRecordNew;
    replacementDocument: File;
    onClose: () => void;
};

function DocumentReplaceConfirm({ currentRecord, replacementDocument, onClose }: DocumentReplaceConfirmProps): JSX.Element {
    const [renameReferences, setRenameReferences] = useState(false);

    const replaceQuery = useReplaceDocument();

    function replace(): void {
        replaceQuery.mutate(
            { currentRecord, replacingDocument: replacementDocument, renameReferences },
            {
                onSuccess: () => {
                    onClose();
                    toastNotification('success', 'Document record replaced!');
                },
            }
        );
    }

    return (
        <Dialog
            isOpen={true}
            onClose={onClose}
            title="Replace Document"
            description={`Do you want to replace ${currentRecord.name} with ${replacementDocument.name}? Any worksheets / other schedules that use this file will no longer be reviewed.`}
            primaryAction="Replace"
            secondaryAction="Cancel"
            type="error"
            onPrimaryActionClick={replace}
            onSecondaryActionClick={onClose}
            isLoading={replaceQuery.isLoading}
        >
            <div className="pb-4">
                <Checkbox
                    label="Rename all references of this file record."
                    onChange={(e): void => setRenameReferences(e.target.checked)}
                />
            </div>
        </Dialog>
    );
}
export default DocumentReplaceConfirm;
